import { useQuery } from '@tanstack/react-query';
import { apiFetchProductCopies } from './apiFetchProductCopies';
import { browserClient } from '../../../react-query';
import { GlobalReactQueryOptions } from '../../../config';

const PRODUCT_COPIES_QUERY_KEY = 'productCopies';

type Params = {
    productId: string;
    page: number;
    pageSize: number;
    sortBy: string;
    sortDirection: 'ASC' | 'DESC';
};

export function useProductCopies({ productId, ...otherParams }: Params) {
    return useQuery(
        [PRODUCT_COPIES_QUERY_KEY, productId, otherParams],
        () => apiFetchProductCopies({ productId, ...otherParams }),
        {
            ...GlobalReactQueryOptions,
            retry: false
        }
    );
}

export const invalidateProductCopies = (productId: string) => {
    return browserClient.invalidateQueries({ queryKey: [PRODUCT_COPIES_QUERY_KEY, productId] });
};
